import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Card, Field, SectionTitle } from "@/components/ui-hud";
import { toast } from "sonner";
import { Send, Mail, Globe, ArrowLeft } from "lucide-react";

export default function Contact() {
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/contact", form);
      setSent(true);
      toast.success("Message sent — we'll get back to you");
    } catch (e) { toast.error(e?.response?.data?.detail || "Error"); }
  };

  return (
    <div className="max-w-4xl mx-auto px-6 py-16">
      <button
        type="button"
        onClick={() => { if (window.history.length > 1) nav(-1); else nav("/"); }}
        data-testid="contact-back-btn"
        className="mb-6 inline-flex items-center gap-2 text-white/55 hover:text-white text-[12px] tracking-widest uppercase mono transition-colors"
      >
        <ArrowLeft className="h-3.5 w-3.5" /> Back
      </button>
      <SectionTitle overline="CONTACT" title="Get in touch." subtitle="Questions about membership, the directory, or getting listed? We're here." />

      <div className="grid md:grid-cols-3 gap-5">
        <Card className="md:col-span-2">
          {sent ? (
            <div className="py-8 text-center">
              <div className="overline text-avail mb-3">MESSAGE RECEIVED</div>
              <div className="font-display text-2xl font-semibold">Thanks — we'll be in touch.</div>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <div className="grid grid-cols-2 gap-3">
                <Field label="Name"><input data-testid="contact-name" required className="input-hud" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></Field>
                <Field label="Email"><input data-testid="contact-email" type="email" required className="input-hud" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} /></Field>
              </div>
              <Field label="Subject"><input data-testid="contact-subject" className="input-hud" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} /></Field>
              <Field label="Message"><textarea data-testid="contact-message" required rows={6} className="input-hud" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} /></Field>
              <button data-testid="btn-contact-submit" className="btn-hud btn-hud-solid"><Send className="h-3.5 w-3.5" /> SEND MESSAGE</button>
            </form>
          )}
        </Card>

        <div className="space-y-4">
          <Card>
            <Mail className="h-5 w-5 text-cyan mb-2" />
            <div className="overline mb-1">GENERAL</div>
            <div className="font-mono text-sm">hello@privatejetpilots.com</div>
          </Card>
          <Card>
            <Globe className="h-5 w-5 text-cyan mb-2" />
            <div className="overline mb-1">NETWORK</div>
            <div className="font-mono text-sm">26,511+ members</div>
            <div className="font-mono text-sm">120+ countries</div>
          </Card>
        </div>
      </div>
    </div>
  );
}
